































































































































import CompSelectBox from '@/components/common/CompSelectBox.vue';
import CompCheckBoxButton from '@/components/common/CompCheckBoxButton.vue';
import {Vue, Component} from 'vue-property-decorator';
import {
  Mall,
  Partner,
  Grade,
  Group,
  GetStatisticsSalesProductRequest,
  GetStatisticsSalesProductSummaryRequest,
  GetStatisticsSalesProduct,
  GetStatisticsSalesProductSummary,
   GetPartnersRequest,
} from 'supporter';
import ClickOutside from 'vue-click-outside';
import {DEFAULT_DATE_RANGE, DEFAULT_TIME_RANGE} from '@/pro/components/common/datepicker/dateRange'
import {PARTNERS_SEARCH_TYPE, PARTNERS_STATUS} from '@/views/statistic/common/getPartners'
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import {getFirstAndEndDay, getToday, addMonth} from '@/utils/dateUtils';
import { namespace } from 'vuex-class';
import debounce from 'lodash.debounce';
import BrandSearcher from '@/components/product/BrandSearcher.vue';

const mallModule = namespace('mall');

@Component({
  components: {CompSelectBox, CompCheckBoxButton, PeriodDateCalendar,BrandSearcher },
  directives: {ClickOutside}
})
export default class SearchProductForm extends Vue {
  // 쇼핑몰
  @mallModule.Getter('mallsGlobal')
  private malls!: Mall[];
  private mallNo: number = 0;
  private partnerName: string = '';
  private memberType: string = 'ALL';
  private showMemberShipGenderTypes: string = 'MALE,FEMALE,UNKNOWN';
  private showPlatformTypes: string = 'PC,MOBILE_WEB,MOBILE_APP';
  private memberGradeNo: string = '';
  private memberGroupNo: string = '';
  private includeClaim: string = 'false';
  private productType: string = 'PRODUCT';
  private saleMethodType: string = '';
  private dateType: string = 'MONTH';
  private today = new Date();
  private todayYear = this.today.getFullYear();
  private mid1Year: number = 2018;
  private mid2Year: number = 2019;
  private productNos: string = '';
  private todayMonth = this.today.getMonth() + 1;
  private brandName:string = '';

  private dateTypes = [
    {
      dateTypeValue: 'MONTH',
      dateTypeName: 'STATISTIC_SALES_MONTH'
    },
    {
      dateTypeValue: 'PERIOD',
      dateTypeName: 'STATISTIC_SALES_PERIOD'
    }
  ];
  private changeDateType() {
    if (this.dateType === 'PERIOD') {
    } else {
    }
  }
  private year: number = new Date().getFullYear();
  private beginYear: number = new Date().getFullYear() - 5 >= 2017 ? new Date().getFullYear() - 5 : 2017;
  private get yearList() {
    const years = [];
    const todayYear = new Date().getFullYear();
    for (let i = this.beginYear; i <= todayYear; i++) {
      years.push({
        value: i,
        name: `${i}${this.$t('COMMON_YEAR')}`
      });
    }
    return years;
  }
  private month: number = new Date().getMonth() + 1;
  private get monthList() {
    const months = [];
    for (let i = 1; i <= 12; i++) {
      months.push({
        value: i,
        name: `${i}${this.$t('COMMON_MONTH')}`
      });
    }
    return months;
  }

  private startDate: string = addMonth(new Date(), -1);
  private endDate: string = getToday();
  private periodOption = {
    havePeriodBtn: true,
    dateType: 'Ymd',
    period: '1m',
    periodTypes: ['td', 'ytd', '1w', '1m']
  };

  private get saleMethodTypeList() {
    const list: any = [
      {
        value: '',
        name: this.$t('STATISTIC_SALES_ALL')
      },
      {
        value: 'PURCHASE',
        name: this.$t('STATISTIC_SALES_PURCHASE')
      },
      {
        value: 'CONSIGNMENT',
        name: this.$t('STATISTIC_SALES_CONSIGNMENT')
      }
    ];
    return list;
  }
  private get productTypeList() {
    const list: any = [
      {
        value: 'PRODUCT',
        name: this.$t('STATISTIC_SALES_PRODUCT')
      },
      {
        value: 'OPTION',
        name: this.$t('STATISTIC_SALES_OPTION')
      }
    ];
    return list;
  }
  private get includeClaimList() {
    const list: any = [
      {
        value: 'false',
        name: this.$t('STATISTIC_SALES_SELECT_FALSE')
      },
      {
        value: 'true',
        name: this.$t('STATISTIC_SALES_SELECT_TRUE')
      }
    ];
    return list;
  }

  // private get memberTypeList() {
  //   let list: any = [
  //     {
  //       value: 'ALL',
  //       name: this.$t('STATISTIC_SALES_ALL')
  //     },
  //     {
  //       value: 'MALL',
  //       name: this.$t('STATISTIC_SALES_MALL')
  //     },
  //     {
  //       value: 'PAYCO',
  //       name: this.$t('STATISTIC_SALES_PAYCO')
  //     },
  //     {
  //       value: 'OPENID',
  //       name: 'OpenID 회원'
  //     },
  //     {
  //       value: 'NEOID',
  //       name: '통합관리회원'
  //     }
  //   ];
  //   return list;
  // }
  private memberShipGenderTypes = {
    name: 'memberShipGenderTypes',
    hasAll: true,
    noBrackets: true,
    data: [
      {
        id: 'ALL',
        value: 'MALE,FEMALE,UNKNOWN',
        dispaly: 'COMMON_ALL_CHECK'
      },
      {
        id: 'MALE',
        value: 'MALE',
        dispaly: 'STATISTIC_SALES_MALE'
      },
      {
        id: 'FEMALE',
        value: 'FEMALE',
        dispaly: 'STATISTIC_SALES_FEMALE'
      },
      {
        id: 'UNKNOWN',
        value: 'UNKNOWN',
        dispaly: 'STATISTIC_SALES_UNCLASSIFIED'
      }
    ]
  };
  private mixinData = {
    memberGradeList: [],
    memberGroupList: []
  };

  private get grades() {
    const grades = [
      {
        value: '',
        name: this.$t('STATISTIC_SALES_ALL')
      }
    ];
    //grades.splice(0,grades.length);
    if (this.mixinData.memberGradeList && this.mixinData.memberGradeList.length) {
      this.mixinData.memberGradeList.forEach((grade: Grade) => {
        if(grade.used==true){
          grades.push({
            value: grade.no.toString(),
            name: grade.name
          });
        }
      });
    }
    this.memberGradeNo = '';
    return grades;
  }
  private get groups() {
    const groups = [
      {
        value: '0',
        name: this.$t('STATISTIC_SALES_ALL')
      },
      {
        value: '-1',
        name: this.$t('STATISTIC_SALES_PERIOD_GROUP_NOT_SET')
      }
    ];
    //groups.splice(0,groups.length);
    if (this.mixinData.memberGroupList && this.mixinData.memberGroupList.length) {
      this.mixinData.memberGroupList.forEach((group: Group) => {
        groups.push({
          value: group.no.toString(),
          name: group.name
        });
      });
    }
    this.memberGroupNo = '0';
    return groups;
  }

  private get mallList() {
    const list: any = [];
    if (this.malls) {
      this.malls.forEach(mall => {
        if (mall.used) {
          list.push({
            value: mall.mallNo,
            name: mall.mallName
          });
        }
      });
    }

    return list;
  }

  private get notReadyEditFlg() {
    const disablFlg = false;
    return disablFlg;
  }

  private platformTypes = {
    name: 'platformTypes',
    hasAll: true,
    noBrackets: true,
    data: [
      {
        id: 'ALL',
        value: 'PC,MOBILE_WEB,MOBILE_APP,',
        dispaly: 'COMMON_ALL_CHECK'
      },
      {
        id: 'PC',
        value: 'PC',
        dispaly: 'STATISTIC_SALES_PLATFORM_TYPE_PC'
      },
      {
        id: 'MOBILE_WEB',
        value: 'MOBILE_WEB',
        dispaly: 'STATISTIC_SALES_PLATFORM_TYPE_MOBILE_WEB'
      },
      {
        id: 'MOBILE_APP',
        value: 'MOBILE_APP',
        dispaly: 'STATISTIC_SALES_PLATFORM_TYPE_MOBILE_APP'
      }
    ]
  };

  private partnerResult: any[] = [];
  private showResult: boolean = false;
  private selectedPartner = {
    targetName: '',
    targetNo: '',
    couponTargetType: 'PARTNER'
  };
  private partners: Partner[] = [];
  private searchPartner = debounce((e:Event) => this.searchPartnerByKeyword(e), 500);
  private async searchPartnerByKeyword(e) {
    const value = (e.target as HTMLInputElement).value;

    if (this.mallNo === undefined) {
      alert(this.$t('COMMON_ERR_MALLNO_NULL'));
      this.$emit('focusMallNo');
    } else {
      const isSelectedPartner = value === this.selectedPartner?.targetName;
      if(!value) {
        this.partnerResult = [];
        this.selectedPartner = {
          targetName: '',
          targetNo: '',
          couponTargetType: 'PARTNER'
        };
        this.partnerName = '';    
        return;
      }
      if (isSelectedPartner) return;
      
      const request : GetPartnersRequest = {
        params: {
          searchType: PARTNERS_SEARCH_TYPE.partnerName,
          keyword: value,
          mallNo: Number(this.mallNo),
          startDateTime: `${DEFAULT_DATE_RANGE.MIN} ${DEFAULT_TIME_RANGE.START}`,
          endDateTime: `${DEFAULT_DATE_RANGE.MAX} ${DEFAULT_TIME_RANGE.END}`,
          partnerStatus: PARTNERS_STATUS.active,
          contractStatuses: PARTNERS_STATUS.active + ',' + PARTNERS_STATUS.suspend,
        }
      };
      const { data } = await this.$api.getPartners(request)
      this.partners = data.contents;

      this.partnerName = value;
      this.partnerResult = [];
      this.selectedPartner = null;
      this.showResult = true;

      const filteredPartnerName = this.partners.filter(({partnerName}) => (
        partnerName.replace(new RegExp(value, 'gi'), '') !== partnerName
      ));
      filteredPartnerName.forEach(({ partnerName, partnerNo }) => {
        const showName = partnerName.replace(new RegExp(value, 'gi'), '<span>$&</span>');
        const searchedPartnerInfo = {
          showName,
          targetName: partnerName,
          targetNo: partnerNo
        }        
        this.partnerResult = [...this.partnerResult, searchedPartnerInfo]
      });
    }
  }
  private clickPartner(partner: any) {
    this.showResult = false;
    this.selectedPartner = {
      targetName: partner.targetName,
      targetNo: partner.targetNo,
      couponTargetType: 'PARTNER'
    };
    this.partnerName = partner.targetName;
  }
  // BRAND
  private get resetBrand(){
    return {
      targetName: '',
      targetNo: '',
      couponTargetType: 'BRAND'
    }
  }
  private selectedBrand = this.resetBrand;

  private size: number = 100;
  private page: number = 1;
  private genderTypeValidate(): boolean {
    if (this.showMemberShipGenderTypes === '') {
      alert(this.$t('VERIFY_MESSAGE_GENDER'));
      return false;
    }
    return true;
  }

  public getYmd() {
    let startYmd = '';
    let endYmd = '';
    let startDateTime = '';
    let endDateTime = '';

    if (this.dateType === 'MONTH') {
      const tempDates = getFirstAndEndDay(this.year, this.month);
      startDateTime = tempDates.startYmd;
      endDateTime = tempDates.endYmd;
    } else if (this.dateType === 'PERIOD') {
      startDateTime = (this.$refs.combinedPeriod as any).startYmdt;
      endDateTime = (this.$refs.combinedPeriod as any).endYmdt;
    }

    startYmd = startDateTime;
    endYmd = endDateTime;

    return {startYmd, endYmd};
  }

  public get productsParams() {
    const {startYmd, endYmd} = this.getYmd();
    const arrProductsNo = this.productNos.split(/[\n,]/).filter(pno => !!pno);
    this.brandName  = this.selectedBrand.targetName;
    return {
      categoryDepth: '',
      categoryNo: '',
      displayBrandNo: this.selectedBrand.targetNo,
      displayCategoryNo: '',
      endYmd,
      genderTypes: this.showMemberShipGenderTypes === 'ALL' ? 'MALE,FEMALE,UNKNOWN' : this.showMemberShipGenderTypes,
      includesClaim: this.includeClaim,
      mallNo: this.mallNo.toString(),
      memberGradeNo: this.memberGradeNo,
      memberGroupNo: this.memberGroupNo,
      memberType: this.memberType,
      page: this.page.toString(),
      partnerNo: this.selectedPartner.targetNo,
      payType: '',
      platformTypes: this.showPlatformTypes === 'ALL' ? 'PC,MOBILE_WEB,MOBILE_APP' : this.showPlatformTypes,
      productNos: arrProductsNo.join(','),
      productType: this.productType,
      saleMethodType: this.saleMethodType,
      size: this.size.toString(),
      startYmd
    }
  }

  private async searchBtnClick(page: number = 1, size: number) {
    if (!this.genderTypeValidate()) {
      return;
    }

    let mallName = '';
    this.malls.forEach((mallInfo: Mall) => {
      if (mallInfo.mallNo === Number(this.mallNo)) {
        mallName = mallInfo.mallName;
        return;
      }
    });

    const arrProductsNo = this.productNos.split(/[\n,]/).filter(pno => !!pno);
    if (arrProductsNo.length > 300) {
      alert(this.$t('STATISTIC_SALES_ERR_MAX_PRODUCTS_NO'));
      return;
    }

    if (size) {
      this.size = size;
    }
    this.page = page;

    const request: GetStatisticsSalesProductRequest = {
      params: this.productsParams
    };
    const {startYmd, endYmd} = this.getYmd();

    const request1: GetStatisticsSalesProductSummaryRequest = {
      params: {
        categoryDepth: '',
        categoryNo: '',
        displayBrandNo: this.selectedBrand.targetNo,
        displayCategoryNo: '',
        endYmd: endYmd,
        genderTypes: this.showMemberShipGenderTypes === 'ALL' ? 'MALE,FEMALE,UNKNOWN' : this.showMemberShipGenderTypes,
        includesClaim: this.includeClaim,
        mallNo: this.mallNo.toString(),
        memberGradeNo: this.memberGradeNo,
        memberGroupNo: this.memberGroupNo,
        memberType: this.memberType,
        page: page.toString(),
        partnerNo: this.selectedPartner.targetNo,
        payType: '',
        platformTypes: this.showPlatformTypes === 'ALL' ? 'PC,MOBILE_WEB,MOBILE_APP' : this.showPlatformTypes,
        productNos: arrProductsNo.join(','),
        productType: this.productType,
        saleMethodType: this.saleMethodType,
        size: this.size.toString(),
        startYmd: startYmd
      }
    };

    $('#loading').show();

    let salesProductcontents: GetStatisticsSalesProduct;
    this.$api.getStatisticsSalesProduct(request).then(ret => {
      const {data} = ret;
      salesProductcontents = data;

      let salesProductSummarycontents: GetStatisticsSalesProductSummary;
      this.$api.getStatisticsSalesProductSummary(request1).then(ret => {
        const {data} = ret;
        salesProductSummarycontents = data;
        this.$emit('setSearchRequest', request);
        this.$emit('setData', salesProductcontents, salesProductSummarycontents, page, this.size, mallName, this.productType);
      });
    });

    $('#loading').hide();
  }
  private reset() {
    this.mallNo = this.malls[0].mallNo;
    this.includeClaim = 'false';
    (this.$refs.memberShipGender as any).setValues('ALL', 'MALE', 'FEMALE', 'UNKNOWN');
    (this.$refs.issuablePlatform as any).setValues('ALL', 'PC', 'MOBILE_WEB', 'MOBILE_APP');
    this.memberType = this.memberTypeList[0].value;
    this.showMemberShipGenderTypes = 'ALL';
    this.showPlatformTypes = 'ALL';
    this.getGrades();
    this.getGroups();
    this.startDate = addMonth(new Date(), -1);
    this.endDate = getToday();
    this.year = new Date().getFullYear();
    this.month = new Date().getMonth() + 1;
    this.partnerName = '';
    this.selectedBrand = this.resetBrand;
    this.selectedPartner = {
      targetName: '',
      targetNo: '',
      couponTargetType: 'PARTNER'
    };
    this.dateType = 'MONTH';
    this.productType = 'PRODUCT';
    this.productNos = '';
    this.saleMethodType = '';
    (this.$refs.brandSearcherRef as BrandSearcher)?.resetBrand();
  }

  private async getGrades() {
    $('#loading').show();
    const memberGradesList = await this.$api.getMemberGrades({params: {mallNo: this.mallNo}});
    const sortGrade = await memberGradesList.data.sort((a: Grade, b: Grade) => a.order - b.order);
    this.mixinData.memberGradeList = sortGrade;
    //this.memberGradeNo = this.grades.length>0?this.grades[0].value.toString():'';
    $('#loading').hide();
  }

  private async getGroups() {
    $('#loading').show();
    const memberGroupsList = await this.$api.getMemberGroups({params: {mallNo: this.mallNo}});
    const sortGroup = await memberGroupsList.data.sort((a: Group, b: Group) => b.order - a.order);
    this.mixinData.memberGroupList = sortGroup;
    //this.memberGroupNo = this.groups.length>0? this.groups[0].value.toString():'';
    $('#loading').hide();
  }

  private async selectMall() {
    this.getGrades();
    this.getGroups();
    await this.$api.getStatisticsMemberTypes({params: {mallNo: this.mallNo.toString()}}).then(ret => {
      const {data} = ret;
      this.memberTypeList = []
      data.forEach((item) => {
        const temp = {
          value: '',
          name: ''
        };
        temp.value = item.type;
        temp.name = item.label;
        this.memberTypeList.push(temp)
      });
    });
  }

  private memberTypeList:{
    value: string;
    name: string;
  }[]=[]
  private async created() {
    this.mallNo = this.malls[0].mallNo;
    await this.$api.getStatisticsMemberTypes({params: {mallNo: this.mallNo.toString()}}).then(ret => {
      const {data} = ret;
      data.forEach((item) => {
        const temp = {
          value: '',
          name: ''
        };
        temp.value = item.type;
        temp.name = item.label;
        this.memberTypeList.push(temp)
      });
    });
    this.selectMall();
  }

  private closeResult() {
    this.showResult = false;
  }
}
